import React from 'react';
import Course from './Course';

const CourseContanier = ({data}) => {
  let courses = data.map((course) => {
    return <Course title={course.title}
                   desc={course.description}
                   img={course.img_src}
                   key={course.id} />
  }); 
  return (
    <div>
      <ul>
        {courses}    
      </ul>
    </div>
  );
}

export default CourseContanier;


// WEBPACK FOOTER //
// ./src/components/courses/CourseContainer.js